module.exports = __webpack_public_path__ + "img/2m.da03fbba.jpg";